import Assessment from '..'
import { connect } from 'react-redux'
import * as assessmentSelector from '../selectors'
import {
  fetchActiveAssessmentCount,
  fetchAssessmentCompletedCount,
  fetchActiveAssessments,
  fetchCompletedAssessments,
  fetchStudentsByStatus,
  fetchAllStudentStatusCounts,
  exportStudentData,
  sendRemindersToStudents,
  resendInvitesToStudents,
  setAssessmentFilters,
  setChartFilters,
  clearChartFilters
} from '../actions'
import selectors from '../../Auth/selectors'

const mapStateToProps = state => ({
  loading: assessmentSelector.selectLoadingStatus(state),
  activeAssessmentCount: assessmentSelector.selectActiveAssessmentCount(state),
  assessmentCompletedCount: assessmentSelector.selectAssessmentCompletedCount(state),

  // Active Assessment selectors
  activeAssessments: assessmentSelector.selectActiveAssessments(state),
  activeAssessmentsPagination: assessmentSelector.selectActiveAssessmentsPagination(state),
  activeAssessmentsMetrics: assessmentSelector.selectActiveAssessmentsMetrics(state),
  stateCityPairsActive: state.SubscribedInstitutes?.activeAssessmentsPagination?.stateCityPairs || [],

  // Completed Assessment selectors
  completedAssessments: assessmentSelector.selectCompletedAssessments(state),
  completedAssessmentsPagination: assessmentSelector.selectCompletedAssessmentsPagination(state),
  completedAssessmentsMetrics: assessmentSelector.selectCompletedAssessmentsMetrics(state),
  stateCityPairsCompleted: state.SubscribedInstitutes?.completedAssessmentsPagination?.stateCityPairs || [],



  // Student data selectors
  studentDataSent: assessmentSelector.selectStudentDataSent(state),
  studentDataPending: assessmentSelector.selectStudentDataPending(state),
  studentDataInProgress: assessmentSelector.selectStudentDataInProgress(state),
  studentDataDroppedOff: assessmentSelector.selectStudentDataDroppedOff(state),
  studentDataCompleted: assessmentSelector.selectStudentDataCompleted(state),
  studentDataLoading: assessmentSelector.selectStudentDataLoading(state),

  // Filter-related props
  assessmentFilters: assessmentSelector.selectAssessmentFilters(state),
  filters: assessmentSelector.selectFilters(state),
  chartFilters: assessmentSelector.selectChartFilters(state),

  instituteDetails: selectors.getInstituteDetails(state),

})

const mapDispatchToProps = {
  fetchActiveAssessmentCount,
  fetchAssessmentCompletedCount,
  fetchActiveAssessments,
  fetchCompletedAssessments,
   // Add new action dispatchers
   fetchStudentsByStatus,
   fetchAllStudentStatusCounts,
   exportStudentData,
   sendRemindersToStudents,
   resendInvitesToStudents,
   setAssessmentFilters,
   setChartFilters,
   clearChartFilters,
}

const ConnectedAssessment = connect(mapStateToProps, mapDispatchToProps)(Assessment)

export default ConnectedAssessment